<template>
  <h2 :id="id + '_h2'" v-if="rubrik">{{ rubrik }}</h2>
  <List
    v-if="listItems && listItems.length"
    :id="id"
    :rubrik="rubrik"
    :listItems="listItems"
    :totalMatchingText="totalMatchingText"
  ></List>
  <Pagination
    v-if="visaPaginering && listItems?.length && totalMatching > take"
    :id="rubrik && rubrik.length > 0 ? id + '_h2' : null"
    :totalMatching="totalMatching"
    :labels="texter"
    :pageSize="take"
    @changePage="getItems"
  />
</template>

<script>
import List from "./components/list.vue";
import utbildningslistservice from "../plugins/utbildningslistservice";
import Pagination from "../pagination/pagination.vue";

export default {
  name: "UtbildningslistBlock",
  props: {
    id: String,
    rubrik: String,
    microServiceApiUrl: String,
    visaPaginering: Boolean,
    texter: Object,
    utbildningOptions: Object,
    arrowToLeft: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      take: 10,
      listItems: undefined,
      totalMatching: 0,
      totalMatchingText: "",
    };
  },
  components: {
    List,
    Pagination,
  },
  created() {
    this.$.appContext.app.config.globalProperties = {
      $arrowToLeft: this.arrowToLeft,
    };
    this.take =
      this.utbildningOptions.take == 0 ? 10 : this.utbildningOptions.take;
    var urlParams = new URLSearchParams(window.location.search);
    var pageNr =
      urlParams.get("page") != null ? parseInt(urlParams.get("page")) : 1;

    this.getItems(pageNr);
  },
  methods: {
    getItems(pageNr) {
      let nrToSkip = (pageNr - 1) * this.take;
      this.utbildningOptions.skip = nrToSkip;
      utbildningslistservice
        .getItems(this.microServiceApiUrl, this.utbildningOptions)
        .then((result) => {
          if (result && result.status == 200) {
            this.listItems = result.data.utbildningListItems?.map((item) => {
              if (
                item.url?.includes("www.umu") &&
                window.location.hostname.includes("www2.umu")
              ) {
                // We are on the www2 site, so we need to change the url to www2
                return {
                  ...item,
                  url: item.url.replace("www.umu", "www2.umu"),
                };
              }
              return item;
            });
            this.totalMatching = result.data.totalMatching;

            if (
              this.visaPaginering &&
              this.totalMatching > 0 &&
              this.totalMatching > this.take
            ) {
              let start = (pageNr - 1) * this.take + 1;
              let end =
                pageNr * this.take <= this.totalMatching
                  ? pageNr * this.take
                  : this.totalMatching;

              this.totalMatchingText = `${this.texter.visar} ${start}-${end} ${this.texter.av} ${this.totalMatching}`;
            }
          }
        });
    },
  },
};
</script>
